import { subscriptionTranslations } from '@focuslee/shared-mini-app';
import dayjs from 'dayjs';
import 'dayjs/locale/cs';
import 'dayjs/locale/ru';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import csCommon from './locales/cs/common.json';
import enCommon from './locales/en/common.json';
import ruCommon from './locales/ru/common.json';
import './types';

const resources = {
    en: { common: enCommon, subscription: subscriptionTranslations.en },
    ru: { common: ruCommon, subscription: subscriptionTranslations.ru },
    cs: { common: csCommon, subscription: subscriptionTranslations.cs },
};

export function initI18n(): void {
    i18next.on('languageChanged', language => {
        dayjs.locale(language);
        if (typeof document !== 'undefined') document.documentElement.lang = language;
    });
    void i18next.use(initReactI18next).init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        defaultNS: 'common',
        interpolation: { escapeValue: false },
        react: { useSuspense: false },
    });
}

export async function changeLanguage(language: string): Promise<void> {
    await i18next.changeLanguage(language);
    dayjs.locale(language);
    if (typeof document !== 'undefined') document.documentElement.lang = language;
}

export { default as i18next } from 'i18next';
